import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-card-nav-item',
  templateUrl: './card-nav-item.component.html',
  styleUrls: ['./card-nav-item.component.scss'],
})
export class CardNavItemComponent {
  @Input() url: string;
  @Input() fragment = '';
  @Input() title: string;
  @Input() icon: string;
  @Input() isNew = false;
  @Input() isNewAnalyses = false;

  @Output() clicked = new EventEmitter();
}
